import { mostraAlertaError, mostraAlertaOk, mostraAlertaPregunta } from "../../../../componentes/alerts/sweetAlert";
import { useEffect, useState } from "react";
import { AxiosPrivado } from "../../../../componentes/axios/Axios";
import { PromocionesEliminar, PromocionesListar } from "../../../../configuracion/apiUrls";

const EliminarPromocion = ({ datos, token, setListaPromociones, ActualizarLista }) => {
    const [eliminar, setEliminar] = useState(false);

    useEffect(() => {
        if (eliminar)
            eliminarPromocion();
    }, [eliminar]);

    const eliminarPromocionPregunta = async () => {
        mostraAlertaPregunta(setEliminar, `¿Deseas eliminar esta promocion ${datos.nombre} de forma permanente?`, "warning");
    };

    const eliminarPromocion = async () => {
        if (!datos.id) {
            mostraAlertaError("Seleccione una promoción");
        } else {
            try {
                AxiosPrivado.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                AxiosPrivado.delete(`${PromocionesEliminar}?id=${datos.id}`)
                    .then(() => {
                        ActualizarLista(PromocionesListar, setListaPromociones);
                        mostraAlertaOk("Registro eliminado correctamente");
                    })
                    .catch((er) => {
                        console.log(er);
                        let msjError = "";
                        switch (er.response.status) {
                            case 400:
                                if (er.response.data && Array.isArray(er.response.data)) {
                                    er.response.data.map(f => {
                                        msjError += f.msg + '. ';
                                    });
                                }
                                break;
                            case 404:
                            case 500:
                                msjError = er.response.data.error;
                                break;
                            default:
                                msjError = "Ocurrió un error desconocido.";
                                break;
                        }
                        mostraAlertaError(msjError, "error");
                    });
            } catch (error) {
                mostraAlertaError("Error en la petición");
            }
        }
        setEliminar(false);
    };    

    return (
        <button type="button" className="btn btn-danger" onClick={eliminarPromocionPregunta}>
            <i className="fas fa-trash" />
        </button>
    );
};

export default EliminarPromocion;